import { lazy } from 'react';

// Types
import { AddressBookCarouselProps as LazyComponentProps } from './AddressBookCarousel.types';

// Components
import withSuspense, { lazyRetry } from '../suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "ageRestrictedMessage" */ './AddressBookCarousel')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'AddressBookCarousel');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as AddressBookCarousel };
